import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import Checkbox from '../../shared/inputs/Checkbox';
import { useParams } from 'react-router-dom';



import { NetworkAxios, UserActivityAxios, OnboardingAxios } from "../../API";
import journeyMapSlice from '../../store/journeyMap/journeyMapSlice';
import CommentInput from '../../shared/inputs/CommentInput';
import authSlice from "../../store/auth/authSlice";
import Avatar from '../../shared/commonComponents/Avatar';

import { POINT_TYPE } from "../../shared/Enum";


const PostComment = (props) => {
    const dispatch = useDispatch();
    let param = useParams();
    const solutionId = param.solutionId;
    //const teamForumId = useSelector((state) => state.auth.loggedInUser.teamForumId);
    const userId = useSelector((state) => state.auth.loggedInUser.userId);
    const teamId = useSelector((state) => state.auth.loggedInUser.teamId);
    const offeringUserId = useSelector((state) => state.auth.loggedInUser.offeringUserId);
    const currentStageId = useSelector((state) => state.appState.currentStage);
    const currentActivityId = useSelector((state) => state.auth.loggedInUser.currentActivityId);
    const loggedInUser = useSelector((state) => state.auth.loggedInUser);

    const stageActivities = useSelector((state) => state.journeyMapSlice.stageActivities);

    const indivisualAssignment = stageActivities.find(x => x.stageId == currentStageId && x.activityTypeId == 3);
    const currentIAActivityId = indivisualAssignment ? indivisualAssignment.activityId : 0;

    let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [deletedFiles, setDeletedFiles] = useState([]);
    const [commentText, setCommentText] = useState("");
    const [fileUploadErrorText, setFileUploadErrorText] = useState("");
    const [isAssignment, setIsAssignment] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(true);
    const [submitBtnText, setSubmitBtnText] = useState("Submit");

    const [fileSizeErrorText, setFileSizeErrorText] = useState("");

    useEffect(() => {
        setFileSizeErrorText("");
    }, []);

    useEffect(() => {
        if (props.editCommentContent) {
            setCommentText(props.editCommentContent.commentText);
            setIsAssignment(props.editCommentContent.isAssignment);
        }
    }, [props.editCommentContent]);

    const onFileChange = (event) => {
        var allowedExtensions = /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.gif|\.GIF|\.png|\.PNG|\.xlsx|\.xls|\.csv|\.XLSX|\.XLS|\.pdf|\.PDF|\.doc|\.DOC|\.docx|\.DOCX|\.pptx|\.PPTX|\.ppt|\.PPT|\.zip|\.ZIP|\.txt|\.TXT|\.svg|\.SVG)$/;
        if (event.target.value != "" && !allowedExtensions.exec(event.target.value)) {
            event.target.value = null;
            return;
        }

        const fileSize = Math.round(event.target.files[0].size / 1024);
        if (fileSize >= 10240) {
            setFileSizeErrorText("File size should be less than 10MB");
            return;
        }

        let tempList = [...Array.from(selectedFiles), ...Array.from(event.target.files)];
        setSelectedFiles(tempList);
        event.target.value = null;
    };

    const onFileUpload = async () => {
        setFileUploadErrorText("");
        if (props.commentFrom == "viewSolution") {
            const newFormData = new FormData();
            newFormData.set("solutionId", solutionId ? solutionId : 0);
            newFormData.set("offeringUserId", offeringUserId ? offeringUserId : 0);
            newFormData.set("userId", userId ? userId : 0);
            newFormData.set("commentText", commentText ? commentText : "");
            Array.from(selectedFiles).forEach(image => {
                newFormData.append('files', image);
            });

            if (props.comment && props.comment.id) {
                newFormData.set("parentComment", props.comment.id);
            }

            newFormData.append("messagePointOfferingId", messagePoint.offeringId);
            newFormData.append("messagePointOfferingUserId", messagePoint.offeringUserId);
            newFormData.append("messagePointConnectionId", messagePoint.connectionId);
            newFormData.append("messagePointActivityId", messagePoint.activityId);
            newFormData.append("messagePointTeamId", messagePoint.teamId);
            newFormData.append("messagePointActionKey", messagePoint.actionKey);
            newFormData.append("messagePointIsBackgroundJob", false);

            if (props.editCommentContent) {
                newFormData.set("id", props.editCommentContent.id);
                //deletedFiles.length > 0 && newFormData.set("deletedFiles", deletedFiles.join());
            }

            NetworkAxios.post("SolutionComment", newFormData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
                .then(function (reponse) {
                    console.log(reponse);
                    setSelectedFiles([]);
                    setCommentText("");
                    if (props.setCommentText) {
                        props.setCommentText('');
                    }

                    setIsAssignment(false);
                    props.reloadComments();
                    props.sendNotification();

                })
                .catch(function (error) {
                    setFileUploadErrorText("There was an error while uploading the file. Please ensure that you are uploading files from your local computer. Files from Cloud sources like OneDrive or files containing assets embedded from external sites cannot be uploaded.");
                    console.log(error);
                    setDisableSubmit(false);
                    setSubmitBtnText("Submit");

                });

        } else {

            if (commentText === "" || commentText === undefined || commentText === null) {
                return;
            }

            // var data = {
            //     forumId: props.forumId,
            //     offeringUserId: offeringUserId,
            //     userId: userId,
            //     teamId: teamId,
            //     stageId: currentStageId,
            //     activityId: currentIAActivityId ? currentIAActivityId : 0,
            //     offeringUserActivityId: currentActivityId,
            //     commentText: commentText,
            //     isAssignment: isAssignment,
            //     files: selectedFiles
            // };

            var indivisualActivities = stageActivities.filter(x => x.activityTypeId == 3 && x.stageId == currentStageId);
            console.log("indivisualActivities", indivisualActivities);

            const newFormData = new FormData();
            var assignmentPostData = {
                forumId: props.forumId ? props.forumId : 0,
                offeringUserId: offeringUserId ? offeringUserId : 0,
                userId: userId ? userId : 0,
                teamId: teamId ? teamId : 0,
                stageId: currentStageId ? currentStageId : 0,
                activityId: currentIAActivityId ? currentIAActivityId : 0,
                offeringUserActivityId: indivisualActivities.length > 0 ? indivisualActivities[0].offeringUserActivityId : 0,
                commentText: commentText ? commentText : "",
                isAssignment: isAssignment
            };
            newFormData.set("forumId", props.forumId ? props.forumId : 0);
            newFormData.set("offeringUserId", offeringUserId ? offeringUserId : 0);
            newFormData.set("userId", userId ? userId : 0);
            newFormData.set("teamId", teamId ? teamId : 0);
            newFormData.set("stageId", currentStageId ? currentStageId : 0);
            newFormData.set("activityId", currentIAActivityId ? currentIAActivityId : 0);
            newFormData.set("offeringUserActivityId", indivisualActivities.length > 0 ? indivisualActivities[0].offeringUserActivityId : 0);
            newFormData.set("commentText", commentText ? commentText : "");
            newFormData.set("isAssignment", isAssignment);
            Array.from(selectedFiles).forEach(image => {
                newFormData.append('files', image);
            });

            newFormData.append("messagePointOfferingId", messagePoint.offeringId);
            newFormData.append("messagePointOfferingUserId", messagePoint.offeringUserId);
            newFormData.append("messagePointConnectionId", messagePoint.connectionId);
            newFormData.append("messagePointActivityId", messagePoint.activityId);
            newFormData.append("messagePointTeamId", messagePoint.teamId);
            newFormData.append("messagePointActionKey", messagePoint.actionKey);
            newFormData.append("messagePointIsBackgroundJob", false);


            //newFormData.append("files", selectedFiles);

            if (props.comment && props.comment.id) {
                // data["parentComment"] = props.comment.id;
                newFormData.set("parentComment", props.comment.id);

                var notificationData = [
                    {
                        offeringId: loggedInUser.offeringId,
                        missionId: loggedInUser.missionId,
                        activityBy: loggedInUser.offeringUserId,
                        offeringUserId: props.comment.offeringUserId,
                        teamId: props.comment.teamId || 0,
                        notificationText: `replied to your comment on the ${props.thread} thread.`,
                        actionRoute: JSON.stringify({ action: "reply-comment", url: window.location.pathname, threadId: props.forumId, commentId: props.comment.id, actionText: "View", stageId: currentStageId })
                    }
                ];
                if (props.comment.offeringUserId !== loggedInUser.offeringUserId) {

                    var requestObject = {
                        requestModel: notificationData,
                        message: messagePoint,
                        isBackgroundJob: false
                    };
                    UserActivityAxios.post('Notification/sendnotifications', requestObject)
                        .then(function (res) {
                            console.log(res);
                        })
                        .catch(function (er) {
                            console.log(er);
                        });
                }
            }
            if (props.editCommentContent) {
                newFormData.set("id", props.editCommentContent.id);
                assignmentPostData["id"] = props.editCommentContent.id;
                deletedFiles.length > 0 && newFormData.set("deletedFiles", deletedFiles.join());
            }
            //

            if (isAssignment) {
                // messagePoint.activityId = indivisualActivityId;
                var postData = { requestModel: assignmentPostData, message: messagePoint };
                NetworkAxios.post("comment/postassignment", newFormData)
                    .then(function (reponse) {
                        console.log(reponse);
                        setFileUploadErrorText("");
                        if (isAssignment) {
                            if (indivisualActivities && indivisualActivities.length > 0) {
                                var date = new Date();
                                var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
                                    date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
                                var utcCompletedDate = new Date(now_utc);
                                var data = [{
                                    OfferingUserId: offeringUserId,
                                    ActivityId: indivisualActivities[0].activityId,
                                    IsComplete: true,
                                    ActivityCompletedBy: loggedInUser.firstName + " " + loggedInUser.lastName,
                                    ActivityCompletedOn: utcCompletedDate
                                }];
                                // messagePoint.activityId = indivisualActivities[0].activityId;
                                var requestObject = {
                                    requestModel: data,
                                    message: messagePoint,
                                    isBackgroundJob: false
                                };
                                UserActivityAxios.put('OfferingUserActivity/updatelearnerdata', requestObject)
                                    .then(function (res) {
                                        console.log(res);
                                        var temp = [...stageActivities];
                                        var index = temp.map(function (e) { return e.activityId; }).indexOf(indivisualActivities[0].activityId);
                                        temp[index].isComplete = true;
                                        temp.sort((a, b) => parseInt(a.sequence) > parseInt(b.sequence) ? 1 : -1);
                                        dispatch(journeyMapSlice.actions.setStageActivities(temp));

                                        GetPoints();
                                    })
                                    .catch(function (er) {
                                        console.log(er);
                                    });
                            }
                        }
                        setSelectedFiles([]);
                        setCommentText("");
                        setIsAssignment(false);
                        props.reloadComments();
                        props.cancelEdit();
                    })
                    .catch(function (error) {
                        setFileUploadErrorText("There was an error while uploading the file. Please ensure that you are uploading files from your local computer. Files from Cloud sources like OneDrive cannot be uploaded.");
                        console.log(error);
                        setDisableSubmit(false);
                        setSubmitBtnText("Submit");

                    });
            }
            else {

                NetworkAxios.post("comment", newFormData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                })
                    .then(function (reponse) {
                        console.log(reponse);
                        if (isAssignment) {

                            if (indivisualActivities && indivisualActivities.length > 0) {

                                var date = new Date();
                                var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
                                    date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());

                                var utcCompletedDate = new Date(now_utc);

                                var data = [{
                                    OfferingUserId: offeringUserId,
                                    ActivityId: indivisualActivities[0].activityId,
                                    IsComplete: true,
                                    ActivityCompletedBy: loggedInUser.firstName + " " + loggedInUser.lastName,
                                    ActivityCompletedOn: utcCompletedDate
                                }];
                                // messagePoint.activityId = indivisualActivities[0].activityId;
                                var requestObject = {
                                    requestModel: data,
                                    message: messagePoint,
                                    isBackgroundJob: false
                                };
                                UserActivityAxios.put('OfferingUserActivity/updatelearnerdata', requestObject)
                                    .then(function (res) {
                                        console.log(res);
                                        var temp = [...stageActivities];
                                        var index = temp.map(function (e) { return e.activityId; }).indexOf(indivisualActivities[0].activityId);
                                        temp[index].isComplete = true;
                                        temp.sort((a, b) => parseInt(a.sequence) > parseInt(b.sequence) ? 1 : -1);
                                        dispatch(journeyMapSlice.actions.setStageActivities(temp));
                                    })
                                    .catch(function (er) {
                                        console.log(er);
                                    });

                            }
                        }

                        setSelectedFiles([]);
                        setCommentText("");
                        setIsAssignment(false);
                        props.reloadComments();
                        props.cancelEdit();
                    })
                    .catch(function (error) {
                        setFileUploadErrorText("There was an error while uploading the file. Please ensure that you are uploading files from your local computer. Files from Cloud sources like OneDrive or files containing assets embedded from external sites cannot be uploaded.");
                        console.log(error);
                        setDisableSubmit(false);
                        setSubmitBtnText("Submit");

                    });
            }

        }
    };

    const hiddenFileInput = React.useRef(null);
    const handleClick = event => {
        console.log(event);
        hiddenFileInput.current.click();
    };

    const removeFile = (item) => {
        setFileUploadErrorText("");
        var tempList = [...selectedFiles];
        var index = selectedFiles.findIndex(x => x.name == item.name);
        tempList.splice(index, 1);
        setSelectedFiles(tempList);

        console.log(item);
        if (item.id) {
            setDeletedFiles([...deletedFiles, item.id]);
        }
    };

    const handleTextAreaChange = (event) => {
        setCommentText(event.target.value);
        if (props.setCommentText) {
            props.setCommentText(event.target.value);
        }
    };

    useEffect(() => {
        if (props.commentText) {
            setCommentText(props.commentText);
        }
    }, [props.commentText]);

    useEffect(() => {
        if (commentText.length > 0) {
            setDisableSubmit(false);
            setSubmitBtnText("Submit");
        } else {
            setDisableSubmit(true);
            setSubmitBtnText("Submit");
        }
    }, [commentText]);


    const handleCheckBoxClick = (event) => {
        setIsAssignment(event.target.checked);
    };



    const GetPoints = () => {
        OnboardingAxios.get('OfferingUsers/getuserpoints/' + loggedInUser.offeringUserId)
            .then(function (response) {
                let data = response.data;
                dispatch(
                    authSlice.actions.setPoints({
                        currentLevel: data.currentLevel,
                        currentRank: data.currentRank,
                        teamRank: data.teamRank,
                        pointsToNextBadge: data.pointsToNextBadge,
                        totalPoints: data.totalPoints,
                        experiencePoints: (data.points.find(x => x.pointsType == POINT_TYPE.experience) ? data.points.find(x => x.pointsType == POINT_TYPE.experience).points : 0) || 0,
                        bonusPoints: (data.points.find(x => x.pointsType == POINT_TYPE.bonus) ? data.points.find(x => x.pointsType == POINT_TYPE.bonus).points : 0) || 0,
                    })
                );
            });
    };

    const getTruncatedFileName = (name) => {
        let split = name.split('.');
        let filename = split[0].substring(0, 40);
        let extension = split[1];
        return filename + '....' + extension;
    }
    return (
        <div className='d-flex' style={{ gap: '10px' }} >
            {!props.editComment && <div className="alignTextCenterColPad-0">
                <Avatar {...loggedInUser} className="small" />
            </div>
            }
            <div className="flex-1">
                <Row className={!props.editComment ? "post-base-rectangle mx-0" : "post-base-rectangle bg-transparent mx-0 mb-0"}>
                    <Col style={{ padding: "0" }}>
                        <Row >
                            <Col>
                                {/* <textarea onChange={handleTextAreaChange} value={commentText} className="assignmentTextBox" id="assignmenttext" name="assignmenttext" rows="4" cols="50" placeholder="Post your Questions/ Insight/ recommendations...."></textarea> */}
                                <CommentInput
                                    onChange={handleTextAreaChange}
                                    value={commentText}
                                    inputClassName="assignmentTextBox"
                                    id="assignmenttext"
                                    name="assignmenttext"
                                />
                            </Col>
                        </Row>
                        <Row className={"mb-3"} >
                            <div className="w-fit">
                                <input style={{ display: "none" }} ref={hiddenFileInput} type="file" onChange={onFileChange} multiple accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*,.zip,.docx,.doc,.pptx,.ppt,.xlsx,.xls,.txt,.TXT" />
                                <button onClick={() => { handleClick(); setFileSizeErrorText(""); }} className="cdx-btn myassingmentattachmentbutton">Attach Files <div className="assignmentAttachment" ></div>  </button>
                                {fileSizeErrorText !== "" && <div sm={12} className="attachmentErrMsg" style={{ marginLeft: 0 }}>{fileSizeErrorText}</div>}
                            </div>
                            <div className="myassingmentCheckboxDiv flex-1 gap-20">

                                {props.showAssignment && loggedInUser.roleId != 5 &&
                                    <Checkbox checked={isAssignment}
                                        onChange={handleCheckBoxClick}
                                        className={props.editCommentContent && props.editCommentContent.isAssignment ? "disabled" : ""}
                                        disabled={props.editCommentContent && props.editCommentContent.isAssignment}
                                        label="Mark this as my assignment" />

                                }

                                {props.editComment
                                    ?
                                    <>
                                        <button className="cdx-btn" onClick={props.cancelEdit}>Cancel</button>
                                        <button className="cdx-btn" disabled={disableSubmit} onClick={(e) => { onFileUpload(); e.target.disabled = true; e.target.innerText = "Saving..."; }}>Save</button>
                                    </>
                                    : <button className="cdx-btn cdx-spinner-btn" disabled={disableSubmit}
                                        onClick={(e) => { onFileUpload(); e.target.disabled = true; setSubmitBtnText("Submitting..."); setFileSizeErrorText(""); setFileSizeErrorText(); }}>
                                        {submitBtnText == "Submitting..." && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>} {submitBtnText} </button>
                                }

                            </div>

                        </Row>
                        {props.editCommentContent && props.editCommentContent.attachments.length > 0 &&
                            <div className='row pt-3 mb-2'>
                                {props.editCommentContent.attachments.map((file) => {
                                    // check if file is already deleted
                                    var isDeleted = deletedFiles.find(x => x == file.id);
                                    if (!isDeleted) {
                                        return (
                                            <div className="col-6 file-list-item">
                                                <div key={`file${file.fileName}`}>
                                                    {file.fileName}
                                                </div>
                                                <div className="delete" onClick={() => removeFile(file)}>Remove</div>
                                            </div>
                                        );
                                    } else
                                        return null;

                                })}

                            </div>
                        }

                        {selectedFiles && selectedFiles.length > 0 &&
                            <Row>
                                <Col sm={6}>
                                    <div className="fileListDiv p-0">
                                        {
                                            selectedFiles.length > 0 && selectedFiles.map((item, index) => {
                                                return <div className="fileList mb-2" key={item.name + index}><span>{item.name.length > 50 ? getTruncatedFileName(item.name) : item.name}</span> <span onClick={() => { removeFile(item); }}>Remove</span></div>;
                                            })
                                        }
                                    </div>
                                </Col>
                                {fileUploadErrorText !== "" && <Col sm={12} className="attachmentErrMsg" style={{ marginLeft: 0 }}>{fileUploadErrorText}</Col>}
                            </Row>}
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default PostComment;